import AgencyBrandThemeMode from "@/models/Agencies/AgencyBrandThemeMode";

export default (value: AgencyBrandThemeMode) => {
    switch (value) {
        case AgencyBrandThemeMode.Light:
            return "Light";
        case AgencyBrandThemeMode.Dark:
            return "Dark";
        default:
            return "Unknown";
    }
} 